
export type ProgramSource = {
    vertexShader: string;
    fragmentShader: string;
};

export const createShader = (
    gl: WebGLRenderingContext,
    type: number,
    source: string
): WebGLShader => {
    const shader = gl.createShader(type)!;
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    // @ts-ignore
    return shader;
};